import type {FC} from 'react';

import type {Variant} from '../ToolBoxButton/types';
import type {Size} from './types';

import * as S from './styles';
import {getIcon} from './utils';

type Props = {
  isFilled?: boolean;
  size?: Size;
  variant: Variant;
  withoutCover?: boolean;
};

export const ToolboxIcon: FC<Props> = ({
  isFilled = false,
  size = 'me',
  variant,
}) => {
  return (
    <S.Container size={size}>
      <S.Icon
        component={getIcon(variant)}
        isFilled={isFilled}
        variant={variant}
      />
    </S.Container>
  );
};
